"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkplaceModuleRoutes = void 0;
var WorkplaceModuleRoutes;
(function (WorkplaceModuleRoutes) {
    WorkplaceModuleRoutes["BasePrefix"] = "workplaces/modules";
    WorkplaceModuleRoutes["ById"] = ":workplaceModuleId";
    WorkplaceModuleRoutes["ByWorkplaceId"] = ":workplaceId";
    WorkplaceModuleRoutes["All"] = "all/:workplaceId";
})(WorkplaceModuleRoutes = exports.WorkplaceModuleRoutes || (exports.WorkplaceModuleRoutes = {}));
